import { BASE_UNIT } from 'ms-styles/theme/Numero';

export const PAGE_PADDING = 8 * BASE_UNIT;

export const PAGE_PADDING_MOBILE = 4 * BASE_UNIT;
